import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ComparisonSet } from 'frontend-utils/utils/constants/benchmark-insight';
import type {
  ComparisonSetDataPointsMissingReason,
  ComparisonSetMissingReason,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

export default class BeniMetaComparisonSet extends Model {
  [Type] = 'benchmark-insight/meta-comparison-set' as const;

  @attr('string') declare comparisonSetType: ComparisonSet;

  // See the COMPARISON_SET_DATA_POINTS_MISSING_REASONS constant for possible reasons.
  @attr
  declare datapointsMissingReasons: ComparisonSetDataPointsMissingReason[];

  @attr('boolean') declare exists: boolean;
  @attr('string') declare extractDate: string | null;

  // When not null and "exists" is true, we cannot show the comparison set for some reason.
  // See the COMPARISON_SET_MISSING_REASONS constant for possible reasons.
  @attr('string') declare missingReason: ComparisonSetMissingReason | null;

  // Indicates whether the comparison set has reference period data.
  // The ref objects in segmentations are only present when referencePeriodMissingReason is not null.
  @attr('string') declare referencePeriodMissingReason: string;

  // Determines whether reference period data should be shown for the comparison set.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasReferencePeriodData() {
    return this.referencePeriodMissingReason === null;
  }

  // Determines whether the data should be shown in app.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isVisible() {
    return this.exists && !this.missingReason;
  }
}
